module.exports = __webpack_public_path__ + "img/noises-19.63c25f70.jpg";